module.exports = __webpack_public_path__ + "assets/img/paperpaperpaper.07ce8c1e.jpg";